import httpRequest from "@/auth/http-client";
import {
  IChangePassword,
  ILogin,
  ILoginTokens,
  IRecoverPassword,
  IRegister,
} from "@/interfaces/auth.interfaces";

class AuthService {
  private baseLoginUrl = "/v1/login";
  private baseSignupUrl = "/v1/signup";
  private baseUserUrl = "/v1/user";

  async register(data: IRegister, accessToken: string): Promise<ILoginTokens> {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    return httpRequest.post(`${this.baseSignupUrl}`, data, config);
  }

  async login(data: ILogin): Promise<ILoginTokens> {
    return httpRequest.post(this.baseLoginUrl, data);
  }

  async recoverPassword(data: IRecoverPassword): Promise<void> {
    return httpRequest.post(`${this.baseLoginUrl}/recoverpassword`, data);
  }

  async changePassword(data: IChangePassword): Promise<void> {
    return httpRequest.post(`${this.baseLoginUrl}/changepassword`, data);
  }

  async confirmEmail(token: string, customerId: string, userId: string): Promise<void> {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        CustomerId: customerId,
      },
    };

    return httpRequest.put(`${this.baseUserUrl}/${userId}/confirmemail`, {}, config);
  }
  async sendConfirmationEmail(token: string, customerId: string, userId: string): Promise<void> {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        CustomerId: customerId,
      },
    };
    return httpRequest.post(`${this.baseUserUrl}/${userId}/sendconfirmationemail`, {}, config);
  }
}

const authService = new AuthService();
export default authService;
